import Reveal from "@/components/base/Reveal";
import { statsData } from "@/mocks/homeData";

export default function StatsBand() {
  return (
    <section className="w-full border-b border-background-200/70 bg-background-100">
      <div className="mx-auto w-full max-w-[1400px] px-4 py-10 md:px-8 md:py-14">
        <Reveal className="mb-8 flex flex-col gap-2 md:flex-row md:items-end md:justify-between">
          <h3 className="font-heading text-xl font-bold text-foreground-950 md:text-2xl">档案规模速览</h3>
          <p className="text-sm text-foreground-600">数字每天都在变动，记录只进不退。</p>
        </Reveal>

        <div className="grid grid-cols-2 gap-4 lg:grid-cols-4 lg:gap-6">
          {statsData.map((stat, index) => (
            <Reveal key={stat.label} delay={index * 80}>
              <div className="h-full rounded-lg border border-background-200/80 bg-background-50 p-5 md:p-6">
                <div className="flex items-baseline gap-1">
                  <span className="font-label text-2xl tracking-tight text-primary-600 md:text-4xl">
                    {stat.value}
                  </span>
                  <span className="text-xs text-foreground-500">{stat.unit}</span>
                </div>
                <p className="mt-3 text-sm text-foreground-700">{stat.label}</p>
              </div>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
}